import React, { useState, useEffect } from 'react';
import './Privacypolicy.css';
import { Link } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import MainNav from '../../Components/Navbar/NewNavbar'
import Loading1 from '../../Components/Loading/Loading1';
const Privacy = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 900);
    }, []);
    if (isLoading) {
        return <Loading1 />;
    }
    return (
        <>
            <MainNav />
            <div className="privacy-container">
                <h2>Privacy Policy</h2>

                <p className='heading'>1. Introduction:</p>
                <p>Astra Clean ("we", "our", "us") is committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website and use our services.</p>

                <p className='heading'>2. Information We Collect:</p>
                <p>We may collect and process the following data about you:</p>
                <ul>
                    <li><span className='subheading'>Personal Information:</span> Name, email address, phone number, and home address.</li>
                    <li><span className='subheading'>Payment Information:</span> Credit/debit card details and billing address.</li>
                    <li><span className='subheading'>Service Information:</span> Details of the services you book with us.</li>
                    <li><span className='subheading'>Usage Data:</span> Information about how you use our website and services.</li>
                    <li><span className='subheading'>Technical Data:</span> IP address, browser type, operating system, and other technical details.</li>
                </ul>

                <p className='heading'>3. How We Use Your Information:</p>
                <p>We use the information we collect to:</p>
                <ul>
                    <li>Provide and manage our services.</li>
                    <li>Process your bookings and payments.</li>
                    <li>Communicate with you about your bookings, account, and any issues or concerns.</li>
                    <li>Improve our website and services.</li>
                    <li>Send you promotional offers and updates, if you have opted in to receive them.</li>
                    <li>Comply with legal obligations and protect our rights.</li>
                </ul>

                <p className='heading'>4. Sharing Your Information:</p>
                <p>We do not sell, trade, or rent your personal information to third parties. We may share your information with:</p>
                <ul>
                    <li><span className='subheading'>Service Providers:</span> Third-party companies that help us operate our business and provide our services (e.g., payment processors, IT support).</li>
                    <li><span className='subheading'>Legal Requirements:</span> Authorities if required by law or to protect our legal rights.</li>
                    <li><span className='subheading'>Business Transfers:</span> In the event of a merger, acquisition, or sale of all or a portion of our assets.</li>
                </ul>

                <p className='heading'>5. Data Security:</p>
                <p>We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no internet transmission or electronic storage method is completely secure, and we cannot guarantee absolute security.</p>

                <p className='heading'>6. Your Rights:</p>
                <p>You have the right to:</p>
                <ul>
                    <li>Access the personal information we hold about you.</li>
                    <li>Request correction of inaccurate or incomplete information.</li>
                    <li>Request deletion of your personal information.</li>
                    <li>Object to the processing of your personal information.</li>
                    <li>Request the transfer of your personal information to another service provider.</li>
                    <li>Withdraw consent at any time, where we rely on your consent to process your data.</li>
                </ul>

                <p className='heading'>7. Cookies and Tracking Technologies:</p>
                <p>We use cookies and similar tracking technologies to enhance your experience on our website. Cookies are small data files stored on your device. You can manage your cookie preferences through your browser settings.</p>

                <p className='heading'>8. Changes to This Privacy Policy:</p>
                <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on our website. Changes are effective immediately upon posting.</p>

                <p className='heading'>9. Contact Us:</p>
                <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:</p>
                <p>Email: <Link to="mailto:lakshjain1218@outlook.com">lakshjain1218@outlook.com</Link></p>
                <p>Phone: <Link to="tel:+916366267882">+91 63662 67882</Link></p>
                <p>Address: Sarjapur, Bangalore, India</p>
            </div>
            <Footer />
        </>
    );
};

export default Privacy;